import { I18nKey } from '@/utils/typings';
import { DialogSize } from '../Dialog/types';
import { InjectionKey } from 'vue';

export interface ConfirmationModalInjectionKeyType {
  openDialog: (
    resolve: (value: boolean | PromiseLike<boolean>) => void,
    confirmationOptions?: ConfirmationModalOptions,
  ) => void;
}

export const confirmationInjectionKeys: Record<
  'form' | 'action',
  InjectionKey<ConfirmationModalInjectionKeyType>
> = {
  action: Symbol('actionConfirmationModalInjectionKey'),
  form: Symbol('formConfirmationModalInjectionKey'),
};

export interface EntityInfo {
  id: string | number;
  name: string;
  iuid?: string | null;
  typeName?: I18nKey;
}

export interface ConfirmationContentData {
  type: 'normal' | 'type1' | 'type2';
  entityData: EntityInfo;
  confirmation: string;
  hint: string;
}

export interface ConfirmationModalOptions {
  title?: string;
  titleIcon?: string;
  text?: string;
  contentData?: ConfirmationContentData;
  confirmationButtonType?: 'Delete' | 'Leave' | 'Save';
  confirmButton?: string;
  cancelButton?: string;
  hideCancelButton?: boolean;
  hideClose?: boolean;
  size?: DialogSize;
  onConfirm?: () => Promise<void>;
  onCancel?: () => Promise<void>;
}
